import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const SplashScreen = ({ onClose, onSurvey }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleMetroMinuto = () => {
    navigate('/metrominuto');
  };

  return (
    <>
      <style>
        {`
          .splash-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background-color: rgba(0, 0, 0, 0.18);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 9999;
          }
          .splash-card {
            background-color: #05B1BD;
            color: #FFD437;
            width: clamp(320px, 60vw, 600px);
            height: auto;
            padding: clamp(24px, 5vw, 48px) clamp(20px, 4vw, 40px);
            border-radius: 12px;
            text-align: center;
            box-shadow: 0 4px 16px rgba(0,0,0,0.18);
            animation: fadeIn 0.8s ease-out;
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(-24px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          .splash-title {
            margin: 0 0 16px;
            font-size: clamp(1.5rem, 5vw, 2.5rem);
            font-weight: 900;
            letter-spacing: 0.03em;
          }
          .splash-text {
            margin-bottom: 16px;
            font-size: clamp(1.15rem, 3.5vw, 1.35rem);
            line-height: 1.48;
            word-break: break-word;
            text-align: center;
          }
          .splash-button-container {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: clamp(12px, 4vw, 24px);
            margin-top: 8px;
          }
          .splash-button {
            background-color: #FFD437;
            color: #305E67;
            border: none;
            padding: clamp(12px, 3vw, 16px) clamp(32px, 8vw, 48px);
            border-radius: 7px;
            cursor: pointer;
            font-size: clamp(1rem, 2.5vw, 1.15rem);
            font-weight: 700;
            transition: background 0.15s, color 0.15s, box-shadow 0.15s;
            box-shadow: 0 2px 10px 0 rgba(0,0,0,0.07);
            box-sizing: border-box;
          }
          .splash-button:active {
            background: #ffe074;
            color: #333;
          }
          @media (max-width: 480px) {
            .splash-card {
              width: calc(100% - 32px);
              padding: 16px 12px;
            }
            .splash-title {
              font-size: 1.3rem;
            }
            .splash-text {
              font-size: 1.1rem;
              margin-bottom: 12px;
            }
            .splash-button-container {
              flex-direction: column;
              gap: 12px;
            }
            .splash-button {
              width: auto;
              padding: 14px clamp(24px, 6vw, 40px);
              font-size: 1.02rem;
            }
          }
        `}
      </style>

      <div className="splash-overlay">
        <div className="splash-card">
          <h1 className="splash-title">
            {t('splashscreen.titulo')}
          </h1>
          <p className="splash-text">
            <span dangerouslySetInnerHTML={{ __html: t('splashscreen.subtitulo') }} />
            <br />
            <span dangerouslySetInnerHTML={{ __html: t('splashscreen.subtitulo2') }} />
          </p>

          <div className="splash-button-container">
            <button className="splash-button" onClick={onSurvey}>
              {t('splashscreen.botonencuesta')}
            </button>

            <button className="splash-button" onClick={onClose}>
              {t('splashscreen.botoncerrar')}
            </button>

            {/* Nuevo botón para Metrominuto */}
            <button className="splash-button" onClick={handleMetroMinuto}>
              Ir a Co'ox
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SplashScreen;
